/**
 * Procedure Categories and Procedures for DM in Paediatric Neurology students
 * Extracted with strict evidence from official NMC PDF (Page 9-10: "Psychomotor Domain - Clinical Skills")
 */
export const PAEDIATRIC_NEUROLOGY_PROCEDURES = {
  "Pediatric Neuro-Diagnostic & Invasive Cranial Procedures": [
    "Lumbar Puncture & Cerebrospinal Fluid (CSF) Analysis",
    "Subdural Tap & Ventricular Tap in Infants/Children",
    "Muscle Biopsy & Nerve Biopsy Performance",
    "Peripheral & Central Venous Line Placement & Arterial Blood Sampling",
    "Cranial Ultrasound (Neurosonogram) Performance in Neonates & Infants",
  ],
  "Pediatric Neurophysiology & Diagnostic Testing Procedures": [
    "Electroencephalography (EEG & Video-EEG / VEEG Recording)",
    "Nerve Conduction Velocity (NCV) & Electromyography (EMG) Studies",
    "Evoked Potentials Testing (Visual Evoked Potential / VEP & Brainstem Auditory Evoked Potential / BAEP)",
    "Pediatric Mechanical Ventilation & Airway Care in Comatose Children",
    "Neurometabolic Screening Tests (Urine & Biochemical Assays)",
  ],
};

export const PAEDIATRIC_NEUROLOGY_CATEGORIES = Object.keys(PAEDIATRIC_NEUROLOGY_PROCEDURES);

export const isDMInPaediatricNeurologyDept = (department) => {
  if (!department) {
    try {
      const u = JSON.parse(
        localStorage.getItem("userData") || localStorage.getItem("user") || "{}"
      );
      department = u.department || (u.departments && u.departments[0]);
    } catch (e) {}
  }
  if (!department) return false;
  const d = String(department).toLowerCase();
  return (
    d.includes("paediatric neurology") ||
    d.includes("pediatric neurology") ||
    d.includes("child neurology")
  );
};
